module.exports = __webpack_public_path__ + "media/assets/images/ace-logo-blue-65e24baecdfd65847f860062c6c2571a.png";